import { AvatarInitials } from '../../components';

export function OrganisationLogo({
  organisation,
  targetSize = 'thumbnail',
  className,
}: {
  organisation: any;
  targetSize?: 'thumbnail' | 'small' | 'medium' | 'large';
  className?: string;
}) {
  if (organisation?.logo === null) {
    return (
      <AvatarInitials
        name={organisation.name}
        color={organisation.color}
        className={className}
        width="50"
        height="50"
      />
    );
  }

  if (!process.env.REACT_APP_VIDEO_DIRECTORY) {
    throw new Error('REACT_APP_VIDEO_DIRECTORY is not defined');
  }

  const logoUrl =
    organisation.logo.breakpoints[targetSize]?.url || organisation.logo.url;

  const logoPath =
    process.env.REACT_APP_VIDEO_DIRECTORY.replace(/\/$/, '') + logoUrl;

  return (
    <div className={`logoWrapper ${className ?? ''}`}>
    <img
      src={logoPath}
      width={
        organisation.logo.breakpoints[targetSize]?.width ??
        organisation.logo.width
      }
      height={
        organisation.logo.breakpoints[targetSize]?.height ??
        organisation.logo.height
      }
      alt={organisation.name}
      className={className}
    />
    </div>
  );
}
